import {Injectable} from '@angular/core';
import {HttpService} from './http-service';

import {Util} from '../app/util';

import {EntrakiService} from "./entraki-service";
import {LogadoService} from "./logado-service";
import {TAction, TCarsale} from "../app/enum";
import {DataService} from "./data-service";
import {MessageService} from "./message-service";

@Injectable()
export class CarbookService extends EntrakiService {


    carrinhos: any[] = [];

    constructor(public http: HttpService, public dataService: DataService, public util: Util,
                public logadoService: LogadoService, public messageService: MessageService) {

        super(http, logadoService);

    }

    payCrebito(braspag: string = '') {

        let carbook = this.getCarrinho();

        return this.payment(TAction.acSave, carbook);

    }

    payBoleto() {

        let carbook = this.getCarrinho();

        return this.payment(TAction.acSave, carbook);

    }

    setStart(carsale: TCarsale, hotspot: any): void {

        //let logado = this.logadoService.getAuth();

        let carbook = this.getCarrinho();
        carbook.Carsale = carsale;
        carbook.Hotspot = hotspot;
        carbook.Paybooks = [];
        carbook.Consumes = [];
        carbook.Payforma = {CreditoQtde: 1, Branded: null, Plastic: null};

    }



    payfim() {

        if (this.getCarrinho().Carsale == TCarsale.csPayout) {

            let count = this.getCarrinho().Paybooks.length;
            this.getCarrinho().Paybooks.splice(0, count-1);

        }

    }

    getIndex() {

        return this.dataService.get('tabselected');

    }

    getCarrinho() {

        if (!this.carrinhos[this.getIndex()]) {

            let carrinho:
                {Carsale: TCarsale, Hotspot: any, Paybooks: any[], Payforma: any} =
                {Carsale: null, Hotspot: null, Paybooks: [], Payforma: {CreditoQtde: 1, Methodo: null, Plastic: null}};

            this.carrinhos[this.getIndex()] = carrinho;

        }

        return this.carrinhos[this.getIndex()];

    }

    paybookPush(paybook: any): number {

        this.getCarrinho().Paybooks.push(paybook);
        return this.getCarrinho().Paybooks.indexOf(paybook);

    }

    paybookTira(paybook: any) {

        let index = this.getCarrinho().Paybooks.findIndex(PB => PB.PaybookID == paybook.PaybookID);
        this.getCarrinho().Paybooks.splice(index, 1);

    }

}



// WEBPACK FOOTER //
// ./src/providers/carbook-service.ts